import React from "react";
// import { widget as section } from '../metadata.json';
import dashboardJson from "../../../metadata.json";
import { Button } from "react-bootstrap";
import OX_Grid from "../Grid/OX_Grid";
import Notification from "../../Notification";
import Switch from "react-switch";
import WidgetModal from "../Modals/WidgetModal";
import "../../public/css/widgetmanager.scss";

class WidgetManager extends React.Component {
  constructor(props) {
    super(props);
    this.core = this.props.args;
    this.state = {
      showModal: false,
      modalType: "",
      modalContent: {},
      checked: {},
    };
    this.refresh = React.createRef();
    this.notif = React.createRef();
    this.handleSwitch = this.handleSwitch.bind(this);
    this.checkedList = {};
  }

  componentDidMount() {
    this.setState({ checked: this.checkedList });
  }

  handleSwitch(checked, event, id) {
    let toggleList = { ...this.state.checked };
    toggleList[id] = checked;
    this.setState({ checked: toggleList });
  }

  widgetOperation = (e, operation) => {
    this.setState({ showModal: true, modalContent: e, modalType: operation });
  };

  //functions for OX_Grid
  renderEmpty() {
    return [<React.Fragment key={1} />];
  }

  generateToggleButton = (dataItem, rule) => {
    var string = this.replaceParams(rule, dataItem);
    var showButton = eval(string);
    this.checkedList[dataItem.name] = showButton;
    showButton = true;
    return (
      <abbr
        className={this.checkedList[dataItem.name] ? "deactivateWidget" : "activateWidget"}
        title={this.checkedList[dataItem.name] ? "Deactivate" : "Activate"}
        key={Math.random()}
      >
        <Switch
          id={dataItem.name}
          onChange={() => this.buttonAction({ name: "toggleActivate" }, dataItem)}
          checked={this.state.checked[dataItem.name]}
          onColor="#86d3ff"
          onHandleColor="#2693e6"
          handleDiameter={10}
          uncheckedIcon={false}
          checkedIcon={false}
          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
          height={20}
          width={33}
          className="react-switch"
        />
      </abbr>
    );
  }

  replaceParams(route, params) {
    if (!params) {
      return route;
    }
    var regex = /\{\{.*?\}\}/g;
    let m;
    while ((m = regex.exec(route)) !== null) {
      // This is necessary to avoid infinite loops with zero-width matches
      if (m.index === regex.lastIndex) {
        regex.lastIndex++;
      }

      // The result can be accessed through the `m`-variable.
      m.forEach((match, groupIndex) => {
        route = route.replace(match, params[match.replace(/\{\{|\}\}/g, "")]);
      });
    }
    return route;
  }

  //calling relevant function with respective to action name
  buttonAction(action, item) {
    if (action.name !== undefined) {
      if (action.name === "toggleActivate" && item.isdeleted == "0") this.widgetOperation(item, "Delete");
      else if (action.name === "toggleActivate" && item.isdeleted == "1") this.widgetOperation(item, "Activate");
      else this.widgetOperation(item, action.name);
    }
  }

  render() {
    return (
      <div className='widget-manager'>
        <Notification ref={this.notif} />
        <OX_Grid
          listOptions={{filterable: true}}
          ref={this.refresh}
          core={this.core}
          elementId={'[data-id="Analytics_Window"]'}
          dataSource={"analytics/widget?show_deleted=true"}
          dataLoaderComponent={"DataLoader"}
          // actions={[
          //   {
          //     name: "toggleActivate",
          //     // rule: "{{isdeleted}}==0",
          //     icon: "fa fa-user",
          //     element: (dataItem) => this.generateToggleButton(dataItem, "{{isdeleted}}==0"),
          //   },
          // ]}
          actionButtonType={"inline"}
          filterable={true}
          sortable={true}
          pageable={true}
          columnConfig={[
            {
              title: "Name",
              field: "name",
              type: "text",
              filterable: true
            },
          ]}
        />

        <WidgetModal osjsCore={this.core} modalType={this.state.modalType} show={this.state.showModal} onHide={() => this.setState({ showModal: false })} content={this.state.modalContent} handleChange={(e) => this.handleChange(e)} notification={this.notif} refreshGrid={this.refresh} />
      </div>
    );
  }
}

export default WidgetManager;
